import React from 'react';
import PropTypes from 'prop-types';
import { StaticRouter, MemoryRouter, BrowserRouter } from 'react-router-dom';

export default function withReactRouter() {
  const Router = ({ children }) => (
    typeof window === 'undefined' ? (
      <StaticRouter basename="/">
        <MemoryRouter>
          {children}
        </MemoryRouter>
      </StaticRouter>
    ) : (
      <BrowserRouter>
        {children}
      </BrowserRouter>
    )
  );

  Router.propTypes = {
    children: PropTypes.node,
  };

  return WrappedComponent => (
    (props) => (
      <Router baseurl="">
        <WrappedComponent {...props} />
      </Router>
    )
  );
}
